// KEGG富集柱形图
import ChartTemplate from '../ChartTemplate';
let
  headers = [], // 标题行
  rows = [], // 数据行
  col_y = 'Query_Num', // Y轴值列
  col_tip = 'RichFactor', // tooltip显示值列
  col_term = 'Term' // term列
  ;
export default {
  extends: ChartTemplate,
  data () {
    return {
      srcSeriesData: null,
      extCPT: () => import('./ExtendComponent.vue')
    }
  },
  computed: {
    extCPTProps () {
      return { dataSourceParam: this.dataSourceParam, dataSource: this.dataSource }
    }
  },
  methods: {
    initDataAfter () {
      headers = this.dataSource[0];
      rows = this.dataSource.slice(1);
    },
    initOption () {
      this.Utility.deepMerge(this.chartOption, this.getDataOption(), this.getBarOption(), this.paramOption);
    },


    // ============ 获取柱形图option
    getBarOption () {
      return {
        chart: { animation: false, type: 'column', inverted: true },
        credits: { enabled: false },
        legend: { enabled: false },
        plotOptions: { series: { dataLabels: { enabled: true, format: '{point.value:.2f}' } } },
        tooltip: { headerFormat: '{point.key}：', pointFormat: '{point.y}' },
        yAxis: { title: { text: 'Gene Number' }, gridLineWidth: 0, tickWidth: 1, tickColor: '#00000066', tickLength: 5, lineWidth: 1, lineColor: '#00000066' },
        xAxis: { tickColor: '#00000066', tickLength: 5, tickWidth: 0, lineWidth: 1, lineColor: '#00000066' },
        title: { text: '' },
        ...this.chartOption
      }
    },
    // ============== 获取数据option
    getDataOption () {
      let categories = [], serieData = [];
      for (let i = 0, l = rows.length; i < l; i++) {
        let row = rows[i];
        categories.push(row[headers.indexOf(col_term)]);
        serieData.push({ value: row[headers.indexOf(col_tip)], y: row[headers.indexOf(col_y)] });
      }
      return {
        xAxis: { labels: { style: { textOverflow: 'none', whiteSpace: 'nowrap' } }, categories: categories },
        series: [{ data: serieData }]
      }
    },

    // 扩展组件的表格行勾选事件
    onExtCPTChanged (srs) {
      rows = srs;
      // if (this.srcSeriesData == null) this.srcSeriesData = this.Utility.clone(this.chartOption.series[0].data);
      // let srcRows = this.srcSeriesData;
      // let newRows = [];
      // for (let i = 0; i < srcRows.length; i++) {
      //   if (sri.indexOf(i) != -1) newRows.push(srcRows[i]);
      // }
      // let option = { series: [{ data: newRows }] };
      let option = this.getDataOption();
      this.chart.update(option);
    }
  }
}